import type { VisitorCustomFieldType } from 'graphql-query-contracts';

import { getVisitorCustomFieldTypeLabelKey } from './customField.constants';

/**
 * User-facing field type label for admin UIs (modal, configuration tabs).
 * Uses i18n when a key exists; otherwise formats the raw API type (underscore segments).
 */
export function getVisitorCustomFieldTypeDisplayLabel(
  type: VisitorCustomFieldType,
  t: (key: string) => string
): string {
  const labelKey = getVisitorCustomFieldTypeLabelKey(type);

  if (labelKey) {
    const translated = t(labelKey);

    if (translated !== labelKey) {
      return translated;
    }
  }

  return type
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
